// extracted by mini-css-extract-plugin
export var noSpinners = "_sg-6";
export var percentageInput = "_sg-7";
export var variantColor1 = "_sg-0";
export var variantColor2 = "_sg-1";
export var variantColor3 = "_sg-2";
export var variantColor4 = "_sg-3";
export var variantColor5 = "_sg-4";
export var variantColor6 = "_sg-5";